<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('subMenu.itemImageUpload') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <div class="row">
            <form class="form-horizontal">
              <div class="form-group">
                <h4 class="lead text-danger text-center strong">
                  {{ $t('orderPage.itemImageUploadAttention') }}
                </h4>
                <div
                  :class="[{ '-drag': isDrag == 'new' }]"
                  @dragover.prevent="checkDrag($event, 'new', true)"
                  @dragleave.prevent="checkDrag($event, 'new', false)"
                  @drop.prevent="onDrop"
                  class="area"
                >
                  <div class="drop container text-center">
                    <div class="row-md-4">
                      <p class="drag-drop-info lead">
                        {{ $t('orderPage.dragAndDropHere') }}
                      </p>
                    </div>
                    <div class="row-md-4">
                      <label
                        for="corporation_file"
                        class="btn btn-success margin-20"
                      >
                        {{ $t('orderPage.orSelectFile') }}
                        <input
                          id="corporation_file"
                          @change="onDrop"
                          :disabled="isLoading"
                          type="file"
                          class="drop__input"
                          style="display: none"
                          accept="image/*"
                          multiple
                        />
                      </label>
                    </div>
                    <div class="row-md-4">
                      <p class="drag-drop-info">
                        {{ $t('orderPage.fileOverwriteAttention') }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column list-area">
                  <h5>{{ $t('orderPage.uploadImageList') }}</h5>
                  <div class="list-area-inner">
                    <ul>
                      <li v-for="(item, index, key) in uploadList" :key="key">
                        <p>{{ item.name }}</p>
                        <span v-if="item.status === 'pending'">{{
                          $t('orderPage.pendingUploadItemImage')
                        }}</span>
                        <span v-else-if="item.status === 'processing'">{{
                          $t('orderPage.processingUploadItemImage')
                        }}</span>
                        <span v-else-if="item.status === 'completed'">{{
                          $t('orderPage.successfulUploadItemImage')
                        }}</span>
                        <span
                          v-else-if="item.status === 'invalid'"
                          class="text-danger"
                          >{{ $t('orderPage.invalidUploadItemImage') }}</span
                        >
                        <span v-else class="text-danger">{{
                          $t('orderPage.failureUploadItemImage')
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ItemRequest from '@/http/ItemRequest'

export default {
  data() {
    return {
      isDrag: null,
      isLoading: false,
      uploadList: [],
      pendingList: [],
    }
  },
  computed: {
    arrowImageType() {
      return ['image/png', 'image/jpg', 'image/jpeg']
    },
    isValidFileType() {
      return (file) => {
        return this.arrowImageType.some((type) => type === file.type)
      }
    },
  },
  methods: {
    checkDrag: function(event, key, status) {
      if (this.isLoading) return false
      if (status && event.dataTransfer.types === 'text/plain') {
        return false
      }
      this.isDrag = status ? key : null
    },
    onDrop: function(event) {
      if (this.isLoading) return
      this.isDrag = null
      let fileList = event.target.files
        ? event.target.files
        : event.dataTransfer.files
      if (fileList.length === 0) return
      this.setupUpload(fileList)
    },
    async setupUpload(fileList) {
      const now = Date.now()
      for (const file of fileList) {
        if (this.isValidFileType(file)) {
          this.pendingList.push({ file, date: now, name: file.name })
          this.uploadList.push(this.createUploadItem(file, 'pending', now))
        } else {
          this.uploadList.push(this.createUploadItem(file, 'invalid', now))
        }
      }
      while (this.pendingList.length !== 0) {
        const splittedItems = this.pendingList.slice(0, 20)
        this.pendingList = this.pendingList.slice(20)
        await this.upload(splittedItems, now)
      }
    },
    createUploadItem(file, status, date) {
      return {
        name: file.name,
        status,
        date,
      }
    },
    getUploadListIndex(item, status = 'pending') {
      return this.uploadList.findIndex(
        (listItem) =>
          listItem.date === item.date &&
          listItem.name === item.name &&
          listItem.status === status
      )
    },
    processingItems: function(items) {
      items.forEach((item) => {
        const index = this.getUploadListIndex(item, 'pending')
        this.uploadList[index].status = 'processing'
      })
    },
    completeItems: function(items) {
      items.forEach((item) => {
        const index = this.getUploadListIndex(item, 'processing')
        this.uploadList[index].status = 'completed'
      })
    },
    failedItems: function(items) {
      items.forEach((item) => {
        const index = this.getUploadListIndex(item, 'processing')
        this.uploadList[index].status = 'failed'
      })
    },
    createFormData(items) {
      const formData = new FormData()
      items.forEach((item) => {
        formData.append('files[]', item.file)
      })
      return formData
    },
    upload: async function(items) {
      const request = new ItemRequest()
      const formData = this.createFormData(items)

      this.isLoading = true
      this.processingItems(items)

      return request
        .uploadImages(formData)
        .then(() => this.completeItems(items))
        .catch(() => this.failedItems(items))
        .finally(() => {
          this.isLoading = false
        })
    },
  },
  beforeRouteLeave(_to_, _from_, next) {
    if (this.isLoading) {
      return next(window.confirm(this.$t('orderPage.uploadAlert')))
    } else {
      next(true)
    }
  },
}
</script>
<style scoped>
.drag-drop-info {
  margin-top: 50px;
}
.area {
  border: 2px dotted #73879c;
  padding: 30px;
  width: 80%;
  margin: auto;
}
.-drag {
  border: 2px dotted red;
}
.list-area {
  width: 80%;
  margin: 20px auto;
}
.list-area-inner {
  border: 1px solid #73879c;
  padding: 20px;
  overflow-y: auto;
  max-height: 300px;
}
.list-area-inner ul li {
  list-style: none;
}
.list-area-inner ul li p {
  width: 200px;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 30px;
  margin-bottom: 0;
}
</style>
